import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import BasicModal from '../../Components/Modal_Basic';
import Checking from '../../Components/Checking';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
/** Services Import */
import Commons from '../../Services/Common/Common';
import Dialog from '../../Services/Common/Dialog';
import IndexedDb from '../../Services/IndexedDb/IndexedDb';
/** Components Import */
import Snackbar from '../../Components/Snackbar';
/** Drawer Import */
import { DrawerActions } from '../../Reducers/DrawerReducer';

function Bm10010(props) {
    const drawerStates = useSelector((state) => state.Drawer); // Drawer Redux 호출
    const gridRef = React.useRef();
    const columnDefs = [
        {
            field: 'groupCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_GroupCd' && f.lanType === 'COL')[0].lanName
                    : '', //그룹코드
            minWidth: 200,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            editable: false,
        },
        {
            field: 'code',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Code' && f.lanType === 'COL')[0].lanName
                    : '', //코드
            minWidth: 200,
            editable: false,
        },
        {
            field: 'name',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CodeNm' && f.lanType === 'COL')[0].lanName
                    : '', //코드명
            editable: true,
            minWidth: 130,
        },
        {
            field: 'sortSeq',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Seq' && f.lanType === 'COL')[0].lanName
                    : '', //순서
        },
        {
            field: 'ref1',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Ref1' && f.lanType === 'COL')[0].lanName
                    : '', //참조1
        },
        {
            field: 'ref2',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Ref2' && f.lanType === 'COL')[0].lanName
                    : '', //참조2
        },
        {
            field: 'ref3',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Ref3' && f.lanType === 'COL')[0].lanName
                    : '', //참조3
        },
        {
            field: 'val1',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Value1' && f.lanType === 'COL')[0].lanName
                    : '', //값1
        },
        {
            field: 'val2',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Value2' && f.lanType === 'COL')[0].lanName
                    : '', //값2
        },
        {
            field: 'val3',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Value3' && f.lanType === 'COL')[0].lanName
                    : '', //값3
        },
        {
            field: 'createDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateDate' && f.lanType === 'COL')[0].lanName
                    : '', //생성일자
            minWidth: 200,
            editable: false,
        },
        {
            field: 'createId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateId' && f.lanType === 'COL')[0].lanName
                    : '', //생성자
            editable: false,
        },
        {
            field: 'updateDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateDate' && f.lanType === 'COL')[0].lanName
                    : '', //수정일자
            minWidth: 200,
            editable: false,
        },
        {
            field: 'updateId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateId' && f.lanType === 'COL')[0].lanName
                    : '', //수정자
            editable: false,
        },
    ];
    const [modalToggle, setModalToggle] = React.useState(false); //코드 체크 팝업

    React.useEffect(() => {
        document.title = '코드관리';
        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '기초관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>코드관리</strong>" +
            '</h1>';
        let a = props.rowData;
        if (props.checkInputs.result) {
            gridRef.current.api.setRowData([
                {
                    groupCd: props.checkInputs.groupCode,
                    code: props.checkInputs.code,
                    newYn: 'Y',
                },
                ...props.rowData,
            ]);
            props.setSaveData([
                {
                    groupCd: props.checkInputs.groupCode,
                    code: props.checkInputs.code,
                },
            ]);
            // a.unshift({
            //   groupCd: props.checkInputs.groupCode,
            //   code: props.checkInputs.code,
            //   createDate: "",
            //   createId: "",
            //   sortSeq: 0,
            //   name: "",
            //   ref1: "",
            //   ref2: "",
            //   ref3: "",
            //   val1: null,
            //   val2: null,
            //   val3: null,
            //   updateDate: "",
            //   updateId: "",
            //   newYn: "Y",
            // });
            // props.setRowData(a);
            props.setCheckInputs({
                ...props.checkInputs,
                groupCode: '',
                code: '',
                result: false,
            });
        }
    }, [props.checkInputs.result]);

    return (
        <div>
            <Section />
            <Card
                wrapStyle={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                }}
            >
                {/* 그리드 버튼 */}
                <AuthGroupButton
                    pageName="BM10010"
                    target="G01"
                    refreshFunc={() => props.Init()}
                    addFunc={() => setModalToggle(true)}
                    saveFunc={() => props.SaveConfirm()}
                    deleteFunc={() => props.DeleteConfirm()}
                />
            </Card>
            <Section />
            <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                {/* 그리드 */}
                <AgGridReact
                    ref={gridRef}
                    animateRows={true}
                    columnDefs={columnDefs}
                    defaultColDef={{
                        flex: 1,
                        minWidth: 100,
                        editable: true,
                        resizable: true,
                        sortable: true,
                        filter: true,
                        floatingFilter: true,
                    }}
                    rowData={props.rowData}
                    rowSelection="multiple"
                    onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)}
                    onCellValueChanged={(e) => {
                        GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData);
                    }}
                    getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                />
            </div>
            {/* 코드 체크 폼 */}
            {modalToggle && (
                <BasicModal
                    name="코드관리"
                    onClose={() => setModalToggle(false)}
                    buttonName1="검사"
                    execLogic={() => props.CheckKeys()}
                >
                    <Checking
                        datas={[
                            {
                                name: '그룹코드',
                                value: props.checkInputs.groupCode,
                                onChange: (e) => {
                                    props.setCheckInputs({
                                        ...props.checkInputs,
                                        groupCode: e.target.value,
                                    });
                                },
                            },
                            {
                                name: '코드',
                                value: props.checkInputs.code,
                                onChange: (e) => {
                                    props.setCheckInputs({
                                        ...props.checkInputs,
                                        code: e.target.value,
                                    });
                                },
                            },
                        ]}
                    />
                </BasicModal>
            )}
        </div>
    );
}

export default Bm10010;
